'use es6';

import PropTypes from 'prop-types';
import { PopoverBodyLiteIcons } from '../../constants/popover';
import PopoverBodyLiteBase from '../PopoverBodyLiteBase';
import { jsx as _jsx } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.personalize.lite.${suffix}`;
const propTypes = {
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
function DataTokenPopoverBodyLite(props) {
  const {
    onEdit,
    onRemove
  } = props;
  const iconButtons = [{
    iconName: PopoverBodyLiteIcons.EDIT,
    onClick: onEdit
  }, {
    iconName: PopoverBodyLiteIcons.REMOVE,
    onClick: onRemove
  }];
  return /*#__PURE__*/_jsx("div", {
    className: "animated-popover-preview",
    children: /*#__PURE__*/_jsx(PopoverBodyLiteBase, {
      "data-test-id": "personalize-popover-body-lite",
      iconButtons: iconButtons,
      i18nKey: i18nKey
    })
  });
}
DataTokenPopoverBodyLite.propTypes = propTypes;
DataTokenPopoverBodyLite.displayName = 'DataTokenPopoverBodyLite';
export default DataTokenPopoverBodyLite;